import React, { useState } from 'react';
// import Logo from "../../../public/logo.jpg";
import "./Header.css";
import { BiMenuAltRight } from 'react-icons/bi';
import OutsideClickHandler from 'react-outside-click-handler';

const Header = () => {

  const [menuOpened, setMenuOpened] = useState(false);
  const getMenuStyles = (menuOpened) => {
      if(document.documentElement.clientWidth <= 800) {
          return {right: !menuOpened &&  "-100%"}
      } 
  }

  return (
    <section className="h-wrapper">
        <div className="flexCenter paddings innerWidth h-container">
            <img src="logo.jpg" alt="logo" width={100}/>

            <OutsideClickHandler 
              onOutsideClick={() => {
                setMenuOpened(false)
              }}
            >
              <div className="flexCenter h-menu"
                style={getMenuStyles(menuOpened)}
              >
                  <a href="#residencies">Residencies</a>
                  <a href="#value">Our Value</a>
                  <a href="#contact">Contact Us</a>
                  <a href="#Get-Started">Get Started</a>
                  <button className='button'>Contact</button>
              </div>
            </OutsideClickHandler>

            {/* INITIALLY THE MENU OPENED WILL BE FALSE. HERE I WILL CONSIDER THE PREVIOUS VALUE  AND INSIDE SETMENUOEPENED I AM OBTAINING A PARAMATER I.E. PREVIOUS IS A PARAMETER*/}
            <div className="menu-icon" onClick={() => setMenuOpened((prev) => !prev)}>
                <BiMenuAltRight size={30}/>
            </div>
        </div>

    </section>
  )
}

export default Header
